import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    background: 'rgba(13, 13, 13, 0.7)',
  },
  box: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: '10px'
  },
  image: {
    width: '60px',
    height: '60px', 
    marginBottom: theme.spacing(1),
  },
}));

const LinearStrip = () => {
  const classes = useStyles();

  const data = [
    { imageUrl: 'https://i.imgur.com/D5TXhvd.png', name: 'Sh. Sukhvinder Singh Sukhu', designation: 'Honble Chief Minister' },
    { imageUrl: 'https://i.imgur.com/Qx9H09H.png', name: 'Sh. Mukesh Agnihotri', designation: 'Hon. Deputy Chief Minister' },
    { imageUrl: 'https://i.imgur.com/VKmMLLA.png', name: 'Sh. Rajesh Dharmani', designation: 'TCP Minister' },
    { imageUrl: 'https://i.imgur.com/X58Td8l.png', name: 'Sh. Devesh Kumar, IAS', designation: 'Principal Secretary, TCP' },
    { imageUrl: 'https://i.imgur.com/vWMvl5N.png', name: 'Sh. Kamal Kant Saroch', designation: 'IAS, Director' },
  ];

  return (
    <Paper className={classes.root} elevation={3}>
      {data.map((item, index) => (
        <div key={index} className={classes.box}>
          <img src={item.imageUrl} alt={item.name} className={classes.image} />
          <div className={classes.text}>
          <Typography variant="subtitle1" style={{ color: 'white' }}>
            {item.name}
          </Typography>
          <Typography variant="caption" style={{ color: 'white' }}>
            {item.designation}
          </Typography>
          </div>
        </div>
      ))}
    </Paper>
  );
};

export default LinearStrip;
